import { useContext } from 'react'
import { LayoutContext } from '../../contexts'
import { useShopify } from '../../contexts/shopify'
import { createCheckout } from '../../shopify'
import { getSegmentAnonymousId } from '../../utils'

const CheckoutCurrencyReplace = () => {
  const { checkouts, replaceCheckout, stores } = useShopify()

  const activeStoreSubdomain = useContext(LayoutContext)?.storeSubdomain

  const replaceCheckoutCurrency = async (
    currency,
    storeSubdomain = activeStoreSubdomain,
  ) => {
    const lineItems = checkouts[storeSubdomain].lineItems.edges.map(
      ({
        node: {
          quantity,
          customAttributes,
          variant: { id },
        },
      }) => ({
        variantId: id,
        quantity,
        customAttributes,
      }),
    )
    const { client } = stores[storeSubdomain]

    const segmentId = await getSegmentAnonymousId()

    try {
      const {
        data: {
          checkoutCreate: { checkout },
        },
      } = await createCheckout(client, {
        input: {
          presentmentCurrencyCode: currency,
          lineItems: lineItems,
        },
      })
      replaceCheckout({ ...checkout, storeSubdomain }, segmentId)
    } catch (error) {
      console.error(error)
    }
  }

  return replaceCheckoutCurrency
}

export default CheckoutCurrencyReplace
